import { z } from 'zod';
import { CATEGORIES } from './categories.js';
export { CATEGORIES, CATEGORY_SLUGS } from './categories.js';
export const Category = z.enum(CATEGORIES).meta({ id: 'Category' });
export const EventStatus = z
    .enum(['draft', 'published', 'cancelled', 'archived'])
    .meta({ id: 'EventStatus' });
export const CandidateStatus = z
    .enum(['pending', 'needs_review', 'applied', 'rejected'])
    .meta({ id: 'CandidateStatus' });
export const DecisionOutcome = z
    .enum(['new', 'duplicate', 'update', 'uncertain', 'invalid'])
    .meta({ id: 'DecisionOutcome' });
export const Trust = z.enum(['low', 'medium', 'high']).meta({ id: 'Trust' });
export const GeoPrecision = z.enum(['venue', 'frazione', 'comune']).meta({ id: 'GeoPrecision' });
export const ImageRights = z
    .enum(['organizer_consent', 'source_license', 'own'])
    .meta({ id: 'ImageRights' });
export const IssueSeverity = z.enum(['error', 'warning', 'info']).meta({ id: 'IssueSeverity' });
export const LinkType = z
    .enum(['official', 'tickets', 'social', 'source', 'other'])
    .meta({ id: 'LinkType' });
export const AdapterType = z
    .enum([
    'jsonld',
    'wp_tribe',
    'ics_rss',
    'css_selectors',
    'llm_generic',
    'bandi',
    'quisalento_pdf',
    'telegram_channel',
    'email_inbox',
    'viaggiareinpuglia',
    'pugliaculture',
    'vivaticket',
    'eventiitaliani',
    'submission',
    'manual',
])
    .meta({ id: 'AdapterType' });
export const Province = z.enum(['LE', 'BR', 'TA']).meta({ id: 'Province' });
//# sourceMappingURL=enums.js.map